import CustomImage from '@space-core/components/customImage'
import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'
import { ThemeMode } from '@space-core/styles/themes/enum'
import styled from 'styled-components'

import { CardOrientation } from './enum'
import { ThumbnailImage } from './types'

type SquareType = {
  width: number
  top: number
}

const CustomOthersImage = styled(CustomImage)<{
  thumbOrientatiion: CardOrientation
  isMobile: boolean
}>`
  ${({ thumbOrientatiion, isMobile }) =>
    `
    width: ${
      thumbOrientatiion === CardOrientation.HORIZONTAL ? '6.25rem' : isMobile ? '5rem' : '11.25rem'
    };
    height: ${
      thumbOrientatiion === CardOrientation.HORIZONTAL ? '6.25rem' : isMobile ? '5rem' : '11.25rem'
    };
  `}
  object-fit: cover;
  border-radius: var(--border-radius-lg);
`

const CustomThumbnailImage = styled(CustomImage)<{ themeMode: ThemeMode }>`
  width: 6.25rem;
  height: 6.25rem;
  z-index: 1;
  background-color: var(--gray-400);
  border: 0.063rem solid var(--white);
  box-shadow: 0 0.5rem 1rem -0.375rem rgb(0, 0, 0, 0.4);

  ${({ themeMode }) =>
    themeMode === ThemeMode.DARK &&
    `
    background-color: var(--gray-300);
    border: 0.063rem solid var(--gray-600);
  `}
`

const Square = styled.div<{ width: number; top: number; themeMode: ThemeMode }>`
  height: 6.25rem;
  border: 0.063rem solid var(--white);
  background-color: var(--gray-500);
  box-shadow: 0 0.5rem 1rem -0.375rem rgb(0, 0, 0, 0.6);

  ${({ width, top }) =>
    `
      width: ${width}rem;
      top: ${top}rem;
    `}

  ${({ themeMode }) =>
    themeMode === ThemeMode.DARK &&
    `
    background-color: var(--gray-400);
    border: 0.063rem solid var(--gray-600);
  `}
`

const ThumbnailImage = ({
  thumbnailImage,
  imageAlt,
  showDepthEffect,
  thumbOrientatiion = CardOrientation.HORIZONTAL,
  themeMode
}: ThumbnailImage) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)

  const squares: SquareType[] = [
    {
      width: 5,
      top: 1
    },
    {
      width: 5.8,
      top: 0.5
    }
  ]

  return (
    <>
      {!showDepthEffect && (
        <CustomOthersImage
          src={thumbnailImage}
          alt={imageAlt}
          thumbOrientatiion={thumbOrientatiion}
          isMobile={isMobile}
        />
      )}
      {showDepthEffect && (
        <div className='_position-relative _d-flex _justify-content-center'>
          <CustomThumbnailImage
            src={thumbnailImage}
            alt={imageAlt}
            themeMode={themeMode}
            className='_position-relative _rounded-lg'
          />

          {squares.map((square, index) => (
            <Square
              key={index}
              className='_position-absolute _rounded-lg'
              width={square.width}
              top={square.top}
              themeMode={themeMode}
              data-test='card-square'
            />
          ))}
        </div>
      )}
    </>
  )
}

export default ThumbnailImage
